import { ContactPerson } from '../types/CourseInstance';

export function getFullContactName(contactPerson: ContactPerson) {
  if (contactPerson.lastName) {
    return `${contactPerson.firstName} ${contactPerson.lastName}`;
  } else {
    return contactPerson.firstName;
  }
}
